import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { TopItemsList } from '@/features/dashboard-charts';
import type { TopItemsData } from '@/entities/dashboard';

interface TopListsGridProps {
  topWarehouses?: TopItemsData;
  topUsers?: TopItemsData;
  isLoading: boolean;
}

export function TopListsGrid({ topWarehouses, topUsers, isLoading }: TopListsGridProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="gap-3 p-4">
        <h3 className="text-base font-semibold">{t('welcome.chart.topwarehouses.label')}</h3>
        <TopItemsList data={topWarehouses} loading={isLoading} />
      </Card>

      <Card className="gap-3 p-4">
        <h3 className="text-base font-semibold">{t('welcome.chart.topusers.label')}</h3>
        <TopItemsList data={topUsers} loading={isLoading} />
      </Card>
    </div>
  );
}
